<template>
    <div id="time-keeping-component">
        <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
            <vs-input v-model="fileName" placeholder="Enter File Name" class="w-full export-file-name-input" />
            <!-- <v-select v-model="selectedFormat" :options="formats" class="my-4" /> -->
        </vs-prompt>
        <vs-table :data="timeKeepingList.items" :max-items="itemsPerPage">
            <div slot="header" class="w-full">
                <h4 class="font-bold text-2xl mb-base">Timekeepings</h4>
                <div class="first-row">
                    <div class="flex align-center justify-between w-left-custom mb-5">
                        <div class="flex align-center ml-6 pl-1 m-res">
                            <p class="font-bold text-grey-custom text-res">Date In-Out: </p>
                            <date-picker class="ml-5 in-out-date-picker" range-separator="  to  " :format="date_format_string" v-model="in_out_date" type="date" :editable="false" range placeholder="From date to date" @change="rangeDateInOut"></date-picker>
                            <date-picker class="ml-5 created-date-picker" range-separator="  to  " :format="date_format_string" v-model="created_date" type="date" :editable="false" range placeholder="Create date" @change="rangeCreateDate"></date-picker>
                        </div>
                        <div class="select-staff">
                          <v-select @input="selectId($event)" :value="selected" label="name" :options="staffListFull" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                        </div>
                    </div>

                    <div class="w-right-custom pl-5 mb-5">
                        <vs-button icon-pack="feather" icon="icon-plus" class="gradient gradient-primary no-shadow mr-0 w-full add-new-btn" @click="addTimeKeepingConfig.isOpen = true">Create</vs-button>
                    </div>
                </div>
                <div class="second-row flex-wrap-reverse items-center flex-grow justify-between mb-2">
                    <div class="flex perpage-search w-left-custom">
                        <div class="con-input-search vs-table--search mb-5 w-full ml-0">
                            <input type="text" class="input-search vs-table--search-input w-full" @keyup="searchTimeKeeping" placeholder="Search staff"/>
                            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                        </div>
                    </div>
                    <div class="flex add-delete w-right-custom pl-5">
                        <vs-button class="gradient gradient-primary no-shadow mb-5 w-full flex-center export-btn" @click="activePrompt=true">
                            <div class="flex align-center text-2xl">
                                <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                                Export
                            </div>
                        </vs-button>
                    </div>
                </div>
            </div>
            <template slot="thead">
                <vs-th class="center-title text-center">#</vs-th>
                <vs-th class="center-title text-center">Staff</vs-th>
                <vs-th class="center-title text-center">In</vs-th>
                <vs-th class="center-title text-center">Out</vs-th>
                <vs-th class="center-title text-center">Note</vs-th>
                <vs-th class="center-title text-center">Created At</vs-th>
                <vs-th class="center-title text-center">Action</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md" @click.native="activeItem = tr, updateTimeKeeping(tr)">
                    <vs-td class="text-center">{{ indextr + 1 }}</vs-td>
                    <vs-td class="text-center break-word text-primary" style="min-width: 100px;" :data="data[indextr].staff_name">{{ tr.staff_name }}</vs-td>
                    <vs-td class="text-center" :data="data[indextr].time_in">
                      <div class="text-center" v-if="tr.time_in">
                        <p class="text-center">{{changeFormat(tr.time_in)}}</p>
                        <p class="text-center">{{getTime(tr.time_in)}}</p>
                      </div>
                      <p class="text-center" v-else>N/A</p>
                    </vs-td>
                    <vs-td class="text-center" :data="data[indextr].time_out">
                      <div class="text-center" v-if="tr.time_out">
                        <p class="text-center">{{changeFormat(tr.time_out)}}</p>
                        <p class="text-center">{{getTime(tr.time_out)}}</p>
                      </div>
                      <p class="text-center" v-else>N/A</p>
                    </vs-td>
                    <vs-td class="text-center break-word" style="min-width: 350px;" :data="data[indextr].note">{{ tr.note }}</vs-td>
                    <vs-td class="text-center" :data="data[indextr].created_at">
                      <div class="text-center" v-if="tr.created_at">
                        <p class="text-center">{{changeFormat(tr.created_at)}}</p>
                        <p class="text-center">{{getTime(tr.created_at)}}</p>
                      </div>
                      <p class="text-center" v-else>N/A</p>
                    </vs-td>
                    <vs-td class="px-6 flex-center leading-none">
                        <img src="../../assets/images/edit-icon.png" class="edit-icon" />
                        <img src="../../assets/images/trash-icon.png" class="trash-icon" @click.stop="activeItem = tr, popupActive = true" />
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-popup class="holamundo delete-reward-popup" title="Delete Item" :active.sync="popupActive">
            <div class="text-center">
                <h3>Do you want to delete this Timekeeping?</h3>
                <div class="flex flex-wrap items-center align-center p-6 justify-center">
                <vs-button class="mr-6 align-center delete-responsive" @click="deleteItem">Delete</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click="popupActive = false">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>

        <add-time-keeping :addTimeKeepingConfig="addTimeKeepingConfig" @AddTimeKeeping="addTimeKeeping"></add-time-keeping>
        <update-time-keeping :updateTimeKeepingConfig="updateTimeKeepingConfig" :updateData="updateData" :key="update_key" @UpdateTimeKeepingData="updateTimeKeepingData"></update-time-keeping>

        <div v-if="timeKeepingList._meta && timeKeepingList._meta.pageCount">
        <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(timeKeepingList._meta.pageCount)"
            :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { changeFormatHelper, formatDateString } from '../../helper/datetimeHelper';
import moment from 'moment';
export default {
    name: 'time-keeping-component',
    components: { DatePicker, vSelect },
    data() {
        let date_format_string = formatDateString();
        return {
            currentPage: 1,
            itemsPerPage: 10,
            totalPage: 3,
            deleteSelect: [],
            options: [ 10,15,20],
            in_out_date: [],
            checkin_from: null,
            checkout_to: null,
            created_date: [],
            created_from: null,
            created_to: null,
            filterStaff: {id: 0, name: 'All staff'},
            typeList: [
                {id: 0, name: 'All type'},
                {id: 1, name: 'In'},
                {id: 2, name: 'Out'},
            ],
            filterType: {id: 0, name: 'All type'},
            page_key: 0,
            date_format_string,
            addTimeKeepingConfig: {
                isOpen: false
            },
            updateTimeKeepingConfig: {
                isOpen: false
            },
            updateData: {},
            update_key: 0,
            popupActive: false,
            activeItem: null,
            selectedId: null,
            staffListFull: [{user_id: 0, name: 'All staff'}],
            selected: {user_id: 0, name: 'All staff'},
            action_type: '',
            fileName: "",
            formats:["xlsx", "csv", "txt"] ,
            selectedFormat: "xlsx",
            activePrompt: false,
            headerTitle: ["ID", "STAFF", "IN","OUT", "NOTE", "CREATED AT"],
            headerVal: ["id", "staff_name", "time_in","time_out", "note", "created_at"],
            staff_name: ''
        }
    },
    watch: {
        addTimeKeepingConfig: {
            immediate: true,
            deep: true,
            handler() {
                if(this.addTimeKeepingConfig.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        },
        updateTimeKeepingConfig: {
            immediate: true,
            deep: true,
            handler() {
                if(this.updateTimeKeepingConfig.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
    },
    methods: {
        searchTimeKeeping({ target }) {
          this.staff_name = target.value
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          if (!this.isOpenLoading) {
            this.openLoadingInDiv();
          }
          this.timer = setTimeout(() => {
            this.currentPage = 1;
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              staff_name: this.staff_name,
              filter_staff_id : this.selected.user_id,
              // created_from : this.created_from,
              // created_to : this.created_to,
              // checkin_from : this.checkin_from,
              // checkout_to : this.checkout_to
            };
            if(this.created_from) {
              obj.created_from = this.created_from;
            }
            if(this.created_to) {
              obj.created_to = this.created_to;
            }
            if(this.checkin_from) {
              obj.checkin_from = this.checkin_from;
            }
            if(this.checkout_to) {
              obj.checkout_to = this.checkout_to;
            }
            this.action_type = "Search";
            this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj).then(() => {
              this.closeLoading();
            });
          }, 500);
        },
        updateTimeKeeping(tr){
          this.updateTimeKeepingConfig.isOpen = true;
          this.updateData = tr;
          this.update_key++;
        },
        exportToExcel() {
          import('@/vendor/Export2Excel').then(excel => {
            const list = this.timeKeepingList.items
            const data = this.formatJson(this.headerVal, list)
            excel.export_json_to_excel({
              header: this.headerTitle,
              data,
              filename: this.fileName,
              bookType: this.selectedFormat
            })
            this.clearFields()
          })
        },
        formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => {
            return v[j]
          }))
        },
        clearFields() {
          this.fileName = "",
          this.selectedFormat = "xlsx"
        },
        openLoadingInDiv(){
          this.$vs.loading({
            container: '#app',
            scale: 0.8
          })
          if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                      color: 'danger',
                      title: 'Notification',
                      text: this.action_type + ' timekeeping failed',
                      acceptText: 'OK'
                  })
              }
          }, 10000);
        },
        closeLoading() {
          this.$vs.loading.close('#app > .con-vs-loading');
          this.isOpenLoading = false;
        },
        selectId(e) {
          this.selected.user_id = e.user_id
          this.selected.name = e.name
          this.selectedId = e.user_id
          const obj = {
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            filter_staff_id: e.user_id,
            // created_from: this.created_from,
            // created_to: this.created_to,
            // checkin_from: this.checkin_from,
            // checkout_to: this.checkout_to,
            staff_name: this.staff_name,
          }
          if(this.created_from) {
            obj.created_from = this.created_from;
          }
          if(this.created_to) {
            obj.created_to = this.created_to;
          }
          if(this.checkin_from) {
            obj.checkin_from = this.checkin_from;
          }
          if(this.checkout_to) {
            obj.checkout_to = this.checkout_to;
          }
          this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj)
        },
        addTimeKeeping(data){
          data.page = this.currentPage;
          data.filter_staff_id = this.selected.user_id;
          // data.created_from = this.created_from,
          // data.created_to = this.created_to,
          // data.checkin_from = this.checkin_from,
          // data.checkout_to = this.checkout_to,
          if(this.created_from) {
            data.created_from = this.created_from;
          }
          if(this.created_to) {
            data.created_to = this.created_to;
          }
          if(this.checkin_from) {
            data.checkin_from = this.checkin_from;
          }
          if(this.checkout_to) {
            data.checkout_to = this.checkout_to;
          }
          data.staff_name = this.staff_name;
          this.action_type = "Add";
          this.$store.dispatch("goPos/ADD_TIME_KEEPING", data).then(() => {
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Add Timekeeping Success",
              color: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Add Timekeeping Fail",
              color: "danger",
              position: "top-right"
            });
          })
          this.addTimeKeepingConfig.isOpen = false;
        },
        updateTimeKeepingData(data){
          data.page = this.currentPage;
          data.filter_staff_id = this.selected.user_id;
          // data.created_from = this.created_from,
          // data.created_to = this.created_to,
          // data.checkin_from = this.checkin_from,
          // data.checkout_to = this.checkout_to,
          if(this.created_from) {
            data.created_from = this.created_from;
          }
          if(this.created_to) {
            data.created_to = this.created_to;
          }
          if(this.checkin_from) {
            data.checkin_from = this.checkin_from;
          }
          if(this.checkout_to) {
            data.checkout_to = this.checkout_to;
          }
          data.staff_name = this.staff_name;
          this.action_type = "Update";
          this.$store.dispatch("goPos/UPDATE_TIME_KEEPING", data).then(() => {
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Update Timekeeping Success",
              color: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Update Timekeeping Fail",
              color: "danger",
              position: "top-right"
            });
          })
          this.updateTimeKeepingConfig.isOpen = false;
        },
        formatDate(day){
          let countryCode = localStorage.getItem('country_code');
          if (countryCode == "AU") {
            return moment(day).format('DD/MM/YYYY');
          } else if (countryCode == "US") {
            return moment(day).format('MM/DD/YYYY');
          } else {
            return moment(day).format('MM/DD/YYYY');
          }
        },
        rangeDateInOut(){
            if(this.in_out_date.length != 0){
              this.checkin_from = this.in_out_date[0] ? this.formatDate(this.in_out_date[0]) : null;
              this.checkout_to = this.in_out_date[1] ? this.formatDate(this.in_out_date[1]) : null;
            } else {
              this.checkin_from = null;
              this.checkout_to = null;
            }
            this.currentPage = 1;
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              // checkin_from: this.checkin_from,
              // checkout_to: this.checkout_to,
              // created_from: this.created_from,
              // created_to: this.created_to,
              filter_staff_id: this.selected.user_id,
              staff_name: this.staff_name,
            }
            if(this.created_from) {
              obj.created_from = this.created_from;
            }
            if(this.created_to) {
              obj.created_to = this.created_to;
            }
            if(this.checkin_from) {
              obj.checkin_from = this.checkin_from;
            }
            if(this.checkout_to) {
              obj.checkout_to = this.checkout_to;
            }
            
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj).then(() => {
              this.closeLoading();
            });
            // if(this.in_out_date[0] == null || this.in_out_date[1] == null){
            //     this.checkin_from = null,
            //     this.checkout_to = null,
            //     this.in_out_date = [];
            //     const obj = {
            //         page: this.currentPage,
            //         "per-page": this.itemsPerPage,
            //     }
            //     this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj)
            // }
        },
        rangeCreateDate(){
            if(this.created_date.length != 0){
              this.created_from = this.created_date[0] ? this.formatDate(this.created_date[0]) : null,
              this.created_to = this.created_date[1] ? this.formatDate(this.created_date[1]) : null;
            } else {
              this.created_from = null;
              this.created_to = null;
            }
            this.currentPage = 1;
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              // created_from: this.created_from,
              // created_to: this.created_to,
              // checkin_from: this.checkin_from,
              // checkout_to: this.checkout_to,
              filter_staff_id: this.selected.user_id,
              staff_name: this.staff_name,
            }

            if(this.created_from) {
              obj.created_from = this.created_from;
            }
            if(this.created_to) {
              obj.created_to = this.created_to;
            }
            if(this.checkin_from) {
              obj.checkin_from = this.checkin_from;
            }
            if(this.checkout_to) {
              obj.checkout_to = this.checkout_to;
            }
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj).then(() => {
              this.closeLoading();
            });
            // if(this.created_date[0] == null || this.created_date[1] == null){
            //     this.created_from = null,
            //     this.created_to = null,
            //     this.created_date = [];
            //     const obj = {
            //         page: this.currentPage,
            //         "per-page": this.itemsPerPage,
            //     }
            //     this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj)
            // }
        },
        changeFormat(date) {
          if(date) {
            return changeFormatHelper(date);
          } else {
            return 'N/A';
          }
        },
        getTime(date) {
            return moment(date).format('hh:mm A');
        },
        changePage(currentPage) {
          this.openLoadingInDiv();
          const obj = {
              page: currentPage,
              "per-page": this.itemsPerPage,
              filter_staff_id: this.selected.user_id,
              // created_from: this.created_from,
              // created_to: this.created_to,
              // checkin_from: this.checkin_from,
              // checkout_to: this.checkout_to,
              staff_name: this.staff_name,
          }
          if(this.created_from) {
            obj.created_from = this.created_from;
          }
          if(this.created_to) {
            obj.created_to = this.created_to;
          }
          if(this.checkin_from) {
            obj.checkin_from = this.checkin_from;
          }
          if(this.checkout_to) {
            obj.checkout_to = this.checkout_to;
          }
          this.action_type = "Get list";
          this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj).then(() => {
            this.closeLoading();
            this.currentPage = currentPage;
            this.page_key++;
          })
        },
        deleteItem() {
          if(this.activeItem) {
            let obj = {
              id: this.activeItem.id
            }
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.action_type = "Remove";
            this.$store.dispatch('goPos/REMOVE_TIME_KEEPING', obj).then(() => {
              this.changePage(this.currentPage);
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: "Remove Timekeeping Success",
                color: "success",
                position: "top-right"
              });
            }).catch((err) => {
              console.log('Error: ', err);
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: "Remove Timekeeping Fail",
                color: "danger",
                position: "top-right"
              });
            })
          }
          this.popupActive = false;
        }
    },
    computed: {
      timeKeepingList(){
        return this.$store.getters["goPos/timeKeepingList"];
      },
      staffList(){
        return this.$store.getters["staffList/staffList"];
      }
    },
    created() {
        let listStaff = [];
        this.$store.dispatch('staffList/GET_STAFF_LIST').then(() => {
          listStaff = this.$store.getters["staffList/staffList"];
          for(let i = 0; i<listStaff.length; i++){
            this.staffListFull.push(listStaff[i]);
          }
        })
        const obj = {
          page : 1,
          "per-page" : 10
        }
        this.$store.dispatch("goPos/GET_LIST_TIME_KEEPING", obj)
    }
}
</script>
